// import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

// const Container = styled.div`
//   width: 100%;
//   display: flex;
//   -moz-box-pack: justify;
//   justify-content: space-between;
//   -moz-box-align: center;
//   align-items: center;
//   margin-bottom: 10%;
//   padding: 67% 0px 0px;
//   position: relative;
// `;

// const TextContainer = styled.div`
//   padding: 20px;
//   position: absolute;
//   top: 0;
//   left: 0;
//   display: flex;
//   flex-direction: column;
//   row-gap: 8px;
// `;

// const ImageWrapper = styled.div`
//   width: 67%;
//   position: absolute;
//   left: 50%;
//   bottom: 0;
//   transform: translate(-50%, 35%);
// `;

export const ModelLoader = () => {

  return (
    // <Container>
    //   <TextContainer>
    //     <Skeleton width="150" height="36" borderRadius="0" />
    //     <Skeleton width="75" height="25" borderRadius="0" />
    //     <Skeleton width="100" height="25" borderRadius="0" />
    //   </TextContainer>
    //   <ImageWrapper>
    //     <Skeleton height="100" borderRadius="0" />
    //   </ImageWrapper>
    // </Container>
    <Skeleton width="375" height="250" borderRadius="0" />
  );
};
